import { useMutation } from '@tanstack/react-query';
import { useInvalidateFilesQueries } from '@/api/hooks/useInvalidateFileQueries';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import type { DeleteFolderParams } from '../interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

export const useDeleteFolderMutation = () => {

  const invalidateFileQueries = useInvalidateFilesQueries();

  const apiClient = useChatApiClient();

  const mutation = useMutation({
    mutationFn: (data: DeleteFolderParams) => {
      return apiClient.workspaces.deleteFolder({
        folderId: data.folderId,
        workspaceId: data.workspaceId,
      });
    },
    onError: (error) => {
      Toast.error({
        title: 'Error',
        body: `We're sorry, there was an issue with your request: ${error.message}`,
      });
    },
    onSuccess: (data) => {
      Toast.alert({
        title: 'Folder Deleted',
      });
      invalidateFileQueries();
      return data;
    },
  });
  return mutation;
};

export default useDeleteFolderMutation;